import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid gap-12 sm:grid-cols-2 md:grid-cols-4 mb-12">
          
          {/* Brand Section */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-tr from-blue-600 to-indigo-600 flex items-center justify-center text-white font-bold shadow-lg">
                L
              </div>
              <span className="text-2xl font-bold text-white tracking-tight">
                Learn<span className="text-blue-500">Pro</span>
              </span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
              The premium EdTech platform for mastering code, design, and business. 
              Join the future of learning today.
            </p>
            
            {/* --- SOCIAL MEDIA ICONS --- */}
            <div className="flex gap-4 pt-4">
              {/* Facebook */}
              <SocialIcon 
                href="https://facebook.com"
                color="hover:bg-[#1877F2]"
                path="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" 
              />
              
              {/* X (Twitter) */}
              <SocialIcon 
                href="https://twitter.com"
                color="hover:bg-black hover:border hover:border-slate-700"
                path="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" 
              />
              
              {/* LinkedIn */}
              <SocialIcon 
                href="https://linkedin.com"
                color="hover:bg-[#0A66C2]"
                path="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" 
              />
              
              {/* Instagram */}
              <SocialIcon 
                href="https://instagram.com"
                color="hover:bg-gradient-to-tr hover:from-yellow-400 hover:via-red-500 hover:to-purple-500"
                path="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" 
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6 tracking-wide text-sm uppercase">Platform</h3>
            <ul className="space-y-3 text-sm">
              <li><FooterLink to="/">Home</FooterLink></li>
              <li><FooterLink to="/courses">Browse Courses</FooterLink></li>
              <li><FooterLink to="/dashboard">Student Dashboard</FooterLink></li>
              <li><FooterLink to="/about">About Us</FooterLink></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-white font-semibold mb-6 tracking-wide text-sm uppercase">Categories</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="hover:text-blue-400 transition cursor-pointer">Web Development</li>
              <li className="hover:text-blue-400 transition cursor-pointer">Data Science</li>
              <li className="hover:text-blue-400 transition cursor-pointer">Cloud Computing</li>
              <li className="hover:text-blue-400 transition cursor-pointer">Machine Learning</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-6 tracking-wide text-sm uppercase">Contact</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2">
                <span className="text-blue-500">✉</span> support@learnpro.com
              </li>
              <li className="flex items-center gap-2">
                <span className="text-blue-500">📞</span> +91 98765 43210
              </li>
              <li className="flex items-center gap-2">
                <span className="text-blue-500">📍</span> Bangalore, India
              </li>
            </ul>
          </div>
        </div>

        {/* Divider & Copyright */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
          <p>© {new Date().getFullYear()} LearnPro Inc. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <span className="hover:text-slate-300 cursor-pointer transition">Privacy Policy</span>
            <span className="hover:text-slate-300 cursor-pointer transition">Terms of Service</span>
            <span className="hover:text-slate-300 cursor-pointer transition">Cookies</span>
          </div>
        </div>
      </div>
    </footer>
  );
}



function FooterLink({ to, children }) {
  return (
    <Link to={to} className="text-slate-400 hover:text-white hover:translate-x-1 transition-all duration-200 inline-block">
      {children}
    </Link>
  );
}

function SocialIcon({ path, href, color }) {
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noreferrer"
      className={`w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 transition-all duration-300 ${color} hover:text-white hover:-translate-y-1 shadow-sm`}
    >
      <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
        <path d={path} />
      </svg>
    </a>
  );
}